/**
 * Color type.
 *
 * Array of 4 elements representing color channel values:
 * 0: red;
 * 1: green;
 * 2: blue;
 * 3: alpha.
 * Each channel value must be in range [0; _QuantumRange_].
 * Alpha channel must be 0 for completely transparent color and quantumRange (255 for 8 bit
 * per channel images) for 100% opaque color.
 */
export type Color = readonly [number, number, number, number];

/**
 * Checks if given argument is assignable to color type.
 *
 * @param candidate
 */
export function isColor(candidate: unknown): candidate is Color {
  if (!Array.isArray(candidate)) {
    return false;
  }
  if (candidate.length !== 4) {
    return false;
  }
  return candidate.every((channel) => typeof channel === "number");
}
